import React from "react";
import { Form, Button, Input, Icon, Row } from 'antd';
import { resetPassword } from "../../apis/apis";

class Reset extends React.Component {
    state = {
        loading: false
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                });
                resetPassword(values.password).then(response => {
                    let data = response.data;
                    if (data.error) {
                        this.setState({
                            msg: data.msg
                        });
                    } else {
                        let i = 5;
                        let intervalId = setInterval(() => {
                            this.setState({
                                msg: `修改成功，即将跳转登录${i}s`
                            });
                            if (i === 0) {
                                this.props.history.push({ pathname: '/login' })
                                window.clearInterval(intervalId);
                            }
                            i--;
                        }, 1000);
                    }
                }).catch(error => {

                })
            }
        })
    }
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不相符!');
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    }
    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const { getFieldDecorator } = this.props.form;
        return (
            <Form id="reset" onSubmit={this.handleSubmit}>
                <Form.Item  {...formItemLayout} label="密码">
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码!',
                        },
                        {
                            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,}$/,
                            message: "密码最少6位，包括至少1个大写字母，1个小写字母，1个数字"
                        },
                        {
                            validator: this.validateToNextPassword,
                        }]
                    })(
                        <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
                    )}
                </Form.Item>
                <Form.Item  {...formItemLayout}
                    label="确认密码">
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '再次輸入密码',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="再次輸入密码" />
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" size="large" style={{ marginTop: "10px" }} htmlType="submit" block>提交{this.state.loading ? <Icon type="loading" /> : null}</Button>
                </Form.Item>
                <Row><div className="msg">{this.state.msg}</div></Row>
            </Form>
        )
    }
}

export default Form.create({ name: "reset" })(Reset);